import classNames from "classnames";
import PropTypes from "prop-types";

export const Body = ({ children, classes }) => {
  return <p className={classNames(classes, "body")}>{children}</p>;
};

Body.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
};
